<template>
  <Dialog ref="dialog"
          width="60%"
          icon="fas fa-map"
          :show-confirm="true"
          @confirm="sendPlanning"
          title="Resumen de planificación">
    <div class="more-info">
      <el-row>
        <el-col :lg="4" :md="12" :sm="24">
          <p class="title">FECHA Y HORARIO</p>
          <p class="content">El {{formatDate(this.generalData.date)}}</p>
        </el-col>
        <el-col :lg="9" :md="12" :sm="24">
          <p class="title">EMPRESA DE TRANSPORTE</p>
          <p class="content">{{this.generalData.enterprise.name}}</p>
        </el-col>
        <el-col :lg="4" :md="12" :sm="24">
          <p class="title">VEHÍCULO</p>
          <p class="content">{{this.generalData.patent.name}}</p>
        </el-col>
        <el-col :lg="7" :md="12" :sm="24">
          <p class="title">CD</p>
          <p class="content">{{this.generalData.distributionCenter.name}}</p>
        </el-col>
        <el-col :lg="6" :md="12" :sm="24">
          <p class="title">CT / CTT</p>
          <p class="content">{{formatText(this.generalData.transferCenter)}}</p>
        </el-col>
      </el-row>
      <div v-if="totalNoPlannable > 0">
        <p class="title">SUBORDENES NO PLANIFICABLES</p>
        <div class="suborders">
          <div class="suborder"><p>no encontradas :</p></div>
          <div class="socCount"><p>{{suborders.notFound}}</p></div>
        </div>
        <div class="suborders">
          <div class="suborder"><p>con estado terminado :</p></div>
          <div class="socCount"><p>{{suborders.finished}}</p></div>
        </div>
        <div class="suborders">
          <div class="suborder"><p>con estado cancelado :</p></div>
          <div class="socCount"><p>{{suborders.canceled}}</p></div>
        </div>
        <div class="total">
          <div class="name"><p>TOTAL :</p></div>
          <div class="totalCount"><p>{{totalNoPlannable}}</p></div>
        </div>
      </div>
      <p class="title">SUBORDENES PLANIFICABLES</p>
      <div class="total-final">
        <div class="name"><p>TOTAL :</p></div>
        <div class="totalCount"><p>{{suborders.plannable}}</p></div>
      </div>
    </div>
  </Dialog>
</template>

<script>
import moment from 'moment';
import Dialog from '../base/Dialog.vue';

export default {
  name: 'Summary',
  components: {
    Dialog,
  },
  data() {
    return {
      suborders: {
        plannable: 0,
        notFound: 0,
        finished: 0,
        canceled: 0,
      },
      generalData: {
        enterprise: {},
        patent: {},
        distributionCenter: {},
        transferCenter: {},
      },
    };
  },
  methods: {
    show(generalData, suborders) {
      this.suborders = suborders;
      this.generalData = generalData;
      this.$refs.dialog.visible(true);
    },
    sendPlanning() {
      this.$emit('sendPlanning');
    },
    closeDialog() {
      this.$refs.dialog.visible(false);
    },
    cleanDialog() {
      Object.assign(this, {
        suborders: {
          plannable: 0,
          notFound: 0,
          finished: 0,
          canceled: 0,
        },
        generalData: {
          enterprise: {},
          patent: {},
          distributionCenter: {},
          transferCenter: {},
        },
      });
    },
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY');
    },
    formatText(text) {
      return text !== null ? text.name : 'Sin seleccionar';
    },
  },
  computed: {
    totalNoPlannable() {
      return this.suborders.notFound + this.suborders.finished + this.suborders.canceled;
    },
  },
};
</script>

<style lang="scss" scoped>
  .more-info {
    margin: 0 0 20px 0;
    text-align: left;
    font-size: 12px;
    .title {
      color: #AAD500;
      font-weight: 600;
      margin: 12px 0 2px 0;
      text-transform: uppercase;
    }
    .socsTitle {
      text-align: right;
      margin: -10px 5px 3px 0;
    }
    .subtitle, .content {
      color: #707070;
      margin: 0 0 5px 0;
      .soc-red-status {
        color: #ff8585;
        margin-left: 6px;
      }
    }
    .content {
      span { font-weight: 400; }
      font-weight: 300;
    }
    .suborders {
      display: flex;
      margin-bottom: 2px;
      p { margin: 8px 5px; }
      .suborder {
        width: calc(100% - 70px);
        float: left;
        text-align: right;
        background-color: #fafafa;
      }
      .socCount {
        width: 70px;
        float: right;
        text-align: center;
        background-color: #efefef;
      }
    }
    .total, .total-final {
      display: flex;
      .name {
        width: calc(100% - 70px);
        text-align: right;
        float: left;
      }
      .totalCount {
        width: 70px;
        float: right;
        color: white;
        background-color: #888888;
        text-align: center;
      }
      .name p, .totalCount p { margin: 4px; }
    }
    .total { margin-bottom: 40px; }
    .total-final .name { background-color: #fafafa; }
  }
</style>
